import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useContractDetail } from '../../../../../contextsProperty/ContextContractDetail';
import { Alert } from '@mui/material';
import Icon from '../../../../../../muiComponents/Icon';
import Card from '../../../../../../muiComponents/Card';
import TextInput from '../../../../../../muiComponents/TextInput/TextInput';
import useUserProfile from '../../../../../../customHooks/useUserProfile';

interface RatesByOccupancyProps {
    validationError: string;
}

const RatesByOccupancy = (props: RatesByOccupancyProps) => {
    const { validationError } = props;
    const { readOnlyUser } = useUserProfile();

    const translate = useTranslate();

    const {
        rateDateEdition,
        handleChangeRateDateEdition,
        isLoadingPanel,
        isBlockedContract,
    } = useContractDetail();

    const occupancyArray = rateDateEdition.occupancy
        .split('|')
        .map(occ => occ.split('.').map(per => parseInt(per)));

    const { maxAdults, maxChildren } = occupancyArray.reduce(
        (acc, [adults, children]) => {
            return {
                maxAdults: Math.max(acc.maxAdults, adults),
                maxChildren: Math.max(acc.maxChildren, children),
            };
        },
        { maxAdults: 0, maxChildren: 0 }
    );

    return (
        <>
            <Alert
                severity='info'
                className='margin-top-10'
                sx={{ '& .MuiAlert-message': { width: '100%' } }}
            >
                <div className='flex flex-end width100perc gap-30'>
                    <div className='flex gap-10'>
                        <Icon iconName='Face' />
                        {translate('adults')}
                    </div>
                    <div className='flex gap-10'>
                        <Icon iconName='ChildCare' />
                        {translate('children')}
                    </div>
                </div>
            </Alert>
            {validationError ? (
                <Alert
                    className='rates-panel__validation-bar'
                    icon={<Icon iconName='ReportProblem' />}
                    severity='error'
                >
                    {translate(validationError)}
                </Alert>
            ) : (
                ''
            )}
            <Card style={{ padding: '20px', overflow: 'auto' }}>
                <table>
                    <thead>
                        <tr className='flex gap-20'>
                            <th
                                style={{ width: '120px', padding: '10px' }}
                            ></th>
                            {Array.from({ length: maxChildren + 1 }).map(
                                (_, indexChil) => {
                                    const children = indexChil;
                                    const childText =
                                        children === 1 ? 'child' : 'children';
                                    return (
                                        <th
                                            key={indexChil}
                                            style={{
                                                width: '220px',
                                                padding: '10px',
                                            }}
                                            className='flex flex-center gap-10 text-seconday-700'
                                        >
                                            <Icon iconName='ChildCare' />
                                            <p>
                                                {children}{' '}
                                                {translate(childText)}
                                            </p>
                                        </th>
                                    );
                                }
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: maxAdults }).map(
                            (_, indexAdul) => {
                                const adults = indexAdul + 1;
                                const adultText =
                                    adults === 1 ? 'adult' : 'adults';
                                return (
                                    <tr
                                        className='flex gap-20 padding-10'
                                        key={adults}
                                    >
                                        <td
                                            style={{ width: '120px' }}
                                            className='flex flex-align-center'
                                        >
                                            <div className='flex gap-10 text-seconday-700'>
                                                <Icon iconName='Face' />
                                                {adults} {translate(adultText)}
                                            </div>
                                        </td>
                                        {Array.from({
                                            length: maxChildren + 1,
                                        }).map((item, indexChil) => {
                                            const children = indexChil;
                                            const targetRate =
                                                rateDateEdition.occupancyRates.occupancies.find(
                                                    rate =>
                                                        rate.adults ===
                                                            adults &&
                                                        rate.children ===
                                                            children
                                                );
                                            return (
                                                <td
                                                    key={indexChil}
                                                    className='flex-column gap-20'
                                                    style={{
                                                        width: '220px',
                                                        padding: '10px',
                                                    }}
                                                >
                                                    {targetRate ? (
                                                        <TextInput
                                                            deleteIcon={false}
                                                            labelText='Rate'
                                                            value={
                                                                targetRate?.abt
                                                            }
                                                            type={'number'}
                                                            inputProps={{
                                                                step: 0.01,
                                                                min: 0,
                                                            }}
                                                            disabled={
                                                                isLoadingPanel ||
                                                                isBlockedContract ||
                                                                readOnlyUser
                                                            }
                                                            handleChange={(
                                                                e: React.ChangeEvent<HTMLInputElement>
                                                            ) => {
                                                                const value =
                                                                    parseFloat(
                                                                        e
                                                                            ?.target
                                                                            ?.value
                                                                    ) || 0;
                                                                handleChangeRateDateEdition(
                                                                    {
                                                                        occupancyRates:
                                                                            {
                                                                                ...rateDateEdition.occupancyRates,
                                                                                occupancies:
                                                                                    rateDateEdition.occupancyRates.occupancies.map(
                                                                                        occItem => {
                                                                                            if (
                                                                                                occItem.adults ===
                                                                                                    targetRate.adults &&
                                                                                                occItem.children ===
                                                                                                    targetRate.children
                                                                                            ) {
                                                                                                return {
                                                                                                    ...occItem,
                                                                                                    abt: value,
                                                                                                    aat: value,
                                                                                                };
                                                                                            }
                                                                                            return occItem;
                                                                                        }
                                                                                    ),
                                                                            },
                                                                        __isChanged:
                                                                            true,
                                                                    }
                                                                );
                                                            }}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </Card>
        </>
    );
};

export default RatesByOccupancy;
